import { render } from "./add-insure.vue?vue&type=template&id=51f0cf44&scoped=true&ts=true"
import script from "./add-insure.vue?vue&type=script&lang=ts"
export * from "./add-insure.vue?vue&type=script&lang=ts"

import "./add-insure.vue?vue&type=style&index=0&id=51f0cf44&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f0cf44"]])

export default __exports__